module.exports = __webpack_public_path__ + "7559d3898db8e882456a8fedd8b2ac72.fbx";